import React from 'react';
import LabeledValueBox from '../../../Elements/LabeledValueBox';

const col = { display: 'grid', gap: 10, maxWidth: 360, width: '100%' };

function LabeledValueBoxDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>With and without a leading icon</div>
      </div>
      <div className='dsg-row'>
        <div style={col}>
          <LabeledValueBox
            label='Account in use'
            value='firstname.lastname@bareinternational.com'
            iconName='fa-solid fa-envelope'
          />
          <LabeledValueBox
            label='Reference'
            value='CD-5515'
          />
        </div>
      </div>

      <div className='dsg-row'>
        <div className='dsg-demo-label'>Long values wrap rather than overflow — narrow container</div>
      </div>
      <div className='dsg-row'>
        <div style={{ ...col, maxWidth: 220 }}>
          <LabeledValueBox
            label='Account in use'
            value='a.very.long.address@bareinternational.com'
            iconName='fa-solid fa-envelope'
          />
        </div>
      </div>
    </div>
  );
}

export const labeledValueBoxDemo = {
  id: 'labeled-value-box',
  title: 'Labeled value box',
  category: 'Cards',
  importPath: 'Elements/LabeledValueBox',
  notes: [
    'ONE fact read back to the user — "Account in use", "Reference" — as a small uppercase label over a value in a bordered inset. Props: label, value, iconName, className (all optional).',
    'The value uses overflow-wrap: anywhere, so an email address or a long id wraps instead of overflowing on a phone.',
    'For SEVERAL facts side by side use the DS definition card instead (.def-cols > .def-card > .def-row) — see the Cards entry. This one is deliberately a single pair.',
    'Usually sits in the body of a Message card, but it is standalone and works anywhere.',
  ],
  snippet: "<LabeledValueBox label='Account in use' value={accountName} iconName='fa-solid fa-envelope' />",
  render: LabeledValueBoxDemoComponent,
};
